<input type="text"
       class="c-input"
       maxlength="255"
       data-automation-id="address-comment"
       [formControl]="addressComment"
       [placeholder]="'bd/event-activity/form.apt_suite' | translate"
>
